import React from "react";
import Layout from "../../layouts/Layout";
import { ContactContainer } from "../../containers";
import { SectionTitle} from "../../components";
const Contact = () => {
  return (
    <>

      <Layout title={"Contact Us"}>
   
        <div className="dg__market__data pt--130 pb--80">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <SectionTitle title={"Contact Us"} /><br/><br/>
                <ContactContainer />
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
};

export default Contact;
